export default {
  "base": "my-1.5 ps-1.5 leading-7 [&>ul]:my-0"
}